module.exports = __webpack_public_path__ + "static/media/Mapa_EstadioAzteca.69648164.png";